import { RoomSubmissionAction } from 'src/common/enums/rooms';
import type { RoomActionDescriptions } from 'src/features/admin/submissions/components/modals/modal.types';

export const roomActionDescriptions: RoomActionDescriptions = {
  [RoomSubmissionAction.EVALUATE]: {
    title: 'Evaluate room',
    buttonDescription: 'Evaluate room',
    description: 'Are you sure you want to evaluate this room?',
  },
  [RoomSubmissionAction.CLEAR_DATE]: {
    title: 'Clear date',
    buttonDescription: 'Clear date',
    description: 'Are you sure you want to clear the scheduled realese date?',
  },
  [RoomSubmissionAction.ACCEPT]: {
    title: 'Accept Room & Notify all',
    buttonDescription: 'Accept & notify',
    description: 'You are about to accept the this room and notify all?',
    tooltipText:
      'This puts the new room on the platform, and displays it on the ‘New Rooms’ section on the user dashboard.',
  },
  [RoomSubmissionAction.ACCEPT_NO_NOTIFICATION]: {
    title: 'Quiet Accept Room',
    buttonDescription: 'Quiet accept',
    description: 'Are you sure you want to quiet-accept this room?',
    tooltipText:
      'A quiet accept sets the room’s status to accepted but doesn’t notify others. The room is not displayed on the ‘New Rooms’ section on the user dashboard. Use this option when you don’t want to reset any user progress that has been made on the room i.e  room completions, etc.',
  },
  [RoomSubmissionAction.READY]: {
    title: 'Is this room ready?',
    buttonDescription: 'Set as ready',
    description: `Are you sure you want to set this room's status to ready?`,
  },
  [RoomSubmissionAction.REJECT]: {
    title: 'Reject room',
    buttonDescription: 'Reject room',
    description: 'Are you sure you want to reject this room?',
  },
};
